import React, { Component } from 'react';
import { isNull, isEmpty } from 'lodash';

import './style.scss';
import Loading from '../../common/loading';
import { Page, PageHeader, Card, DataList, TextButton, FlushButtons } from '../../common/ui';
import { API_PREFERENCES, WHITELIST } from '../../config';
import ModalWhiteList from '../../common/modal/modalWhiteList';
import { randomString } from '../../common/actions/randomString';
import { compareString } from '../../common/actions/compareString';
import { controlRole } from '../../common/actions/controlRole';
import { withNavigate } from '../../utility';
import axiosInstance from '../../axiosInstance';

class whitelist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // contiene la lista delle licenze nella whitelist
            getWhiteList: {},

            hasClickNewKey: false,
            hasClickNewIp: false,
            hasClickEdit: false,
            hasClickRemoveIp: false,
            hasClickRemoveKey: false,

            // ip di riferimento nel caso si volesse editare o rimuovere
            ipReference: '',
            // chiave di riferimento nel caso si volesse editare o rimuovere
            keyReference: '',
            // sottochiave di riferimento nel caso si volesse editare o rimuovere
            subKeyReference: '',
            // tutto il contenuto della chiave selezionata (variabile temporanea di appoggio)
            keyContentReference: '',
            // usato per avere come riferimento l'ip da sostituire o eliminare durante l'edit
            keyIp: '',

            // variabili di appoggio per salvare nello stato gli indirizzi ip cui voglio apportare modifiche
            allElementV4: [],
            allElementV6: [],

            shortId: randomString(),

            modal: false,
            isLoading: true,

            loadingForRole: true
        }
        this.toggleModal = this.toggleModal.bind(this);
    }

    /**
     * Il mount e l'update sono uguali, poiche se navigo tra i link di react router, dopo aver
     * caricato questa pagina, esegue solo il mount, mentre se refresho la pagina carica l'update.
     * 
     * (Esempio: se vado una prima volta sulla pagina utenti, dopo il mount carica update.
     * Se dopo il caricamento, senza refreshare, navigo e vado ad altre parti, esempio player, e poi ritorno,
     * react carica solo il mount e nemmeno una volta update.)
     */
    componentDidMount() {
        // se l'utente non ha nessun permesso per visualizzare le whitelist, viene rispedito alla home
        if (!isEmpty(this.props.role.preferences)) {
            if (!controlRole(this.props.role.preferences, "api/Preferences", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare le whitelist!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getWhiteList();
                }
            }
        }
    }

    componentDidUpdate() {
        // se l'utente non ha nessun permesso per visualizzare le whitelist, viene rispedito alla home
        if (!isEmpty(this.props.role.preferences)) {
            if (!controlRole(this.props.role.preferences, "api/Preferences", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare le whitelist!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getWhiteList();
                }
            }
        }

        if (!localStorage.token) {
            this.props.handleNavigation(this.props.navigate, '/');
        }
    }

    /**
     * Usato solo per chiudere la modale, poiche resetta tutto lo state
     */
    toggleModal = () => {
        this.setState(prevState => ({ modal: !prevState.modal }));
        this.setState({
            hasClickEdit: false,
            hasClickNewKey: false,
            hasClickNewIp: false,
            hasClickRemoveIp: false,
            hasClickRemoveKey: false,
            ipReference: '',
            keyIp: '',
            keyReference: '',
            subKeyReference: '',
            keyContentReference: '',
            allElementV4: [],
            allElementV6: [],
            shortId: randomString()
        });
    }

    /**
     * Chiama il BE e ritorna la lista degli indirizzi della whitelist
     * 
     * @return type array
     */
    getWhiteList = async () => {
        this.setState({ isLoading: true });
        try {
            let response = await axiosInstance.get(`${API_PREFERENCES}/${WHITELIST}`);
            this.setState({
                getWhiteList: response.data,
                isLoading: false
            });
        } catch (result) {
            const { errorNotify } = this.props;
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                switch (result.response) {
                    default: errorNotify(`Error ${result.response.status} su ${API_PREFERENCES} - GET`); break;
                }
            }
        }
    }

    /**
     * Prima di mandare i dati al BE, bisogna mettere il /32 finale
     * Questa funzione aggiunge il /32 finale a tutti gli indirizzi.
-     */
    resanitizeWhiteList = (list) => {
        let tempList = [];
        // eslint-disable-next-line
        list.map(el => {
            tempList.push(el);
        });

        this.setState({ getWhiteList: tempList });
    }

    /**
     * Se viene cliccato il pulsante nuova chiave, attiva la modale per creare un nuovo gruppo
     */
    hasClickNewKey = () => {
        this.setState({ hasClickNewKey: true });
        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante nuovo ip, attiva la modale per inviare l'ip nuovo.
     * 
     * @param keyName è il nome della chiave (es: Player)
     * @param keyContent è il contenuto di tutta la chiave (es: Contenuto di Player)
     * @param subKey è il nome contenuto nella chiave (es: Ipv4)
     * 
     */
    hasClickNewIp = (keyName, keyContent, subKey) => {
        this.setState({
            hasClickNewIp: true,
            keyReference: keyName,
            keyContentReference: keyContent,
            subKeyReference: subKey
        });

        setTimeout(() => {
            this.getAllIp();
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante edit ip, attiva la modale per inviare l'ip editato.
     * 
     * @param keyName è il nome della chiave (es: Player)
     * @param keyContent è il contenuto di tutta la chiave (es: Contenuto di Player)
     * @param subKey è il nome contenuto nella chiave (es: Ipv4)
     * @param ip è l'ip che deve essere modificato (es: 192.168.0.1) 
     * @param keyIp è la chiave dell'indice dell'indirizzo ip che deve essere sostituito
     * 
     */
    hasClickEdit = (keyName, keyContent, subKey, ip, keyIp) => {
        this.setState({
            hasClickEdit: true,
            keyReference: keyName,
            keyContentReference: keyContent,
            subKeyReference: subKey,
            ipReference: ip,
            keyIp: keyIp
        });

        setTimeout(() => {
            this.getAllIp();
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante rimuovi ip, attiva la modale per rimuovere l'ip
     * 
     * @param keyName è il nome della chiave (es: Player)
     * @param keyContent è il nome della chiave (es: Contenuto di Player)
     * @param subKey è il nome contenuto nella chiave (es: Ipv4)
     * @param ip è l'ip che deve essere eliminato (es: 192.168.0.1) 
     * @param keyIp è la chiave dell'indice dell'indirizzo ip che deve essere eliminato
     * 
     */
    hasClickRemoveIp = (keyName, keyContent, subKey, ip, keyIp) => {
        this.setState({
            hasClickRemoveIp: true,
            keyReference: keyName,
            keyContentReference: keyContent,
            subKeyReference: subKey,
            ipReference: ip,
            keyIp: keyIp
        });
        setTimeout(() => {
            this.getAllIp();
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Se viene cliccato il pulsante rimuovi key, attiva la modale per rimuovere la key
     * 
     */
    hasClickRemoveKey = (key) => {
        this.setState({
            hasClickRemoveKey: true,
            keyReference: key
        });
        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 200);
    }

    /**
     * Aggiunge una nuova chiave alla lista.
     * 
     * @param key è la nuova chiave
     */
    addKey = (key) => {
        let data = {
            [key]: {
                "Ipv4": null
            }
        }
        this.props.sendEditPreferences(WHITELIST, data);
        this.toggleModal();

        setTimeout(() => {
            this.getWhiteList();
        }, 200)
    }

    /**
     * Aggiunge un nuovo indirizzo alla lista degli indirizzi.
     * 
     * @param newIp
     */
    addNewIp = (newIp) => {

        let listTemp = [];
        let data = {};

        // è un indirizzo v4 da modificare?
        if (compareString(this.state.subKeyReference, 'ipv4')) {
            listTemp = this.state.allElementV4;

            if (newIp.includes("/"))
                listTemp.push(newIp);
            else
                listTemp.push(newIp + '/32');

            // controllo se la chiave iniziale aveva anche gli indirizzi v6
            if (isEmpty(this.state.allElementV6)) {
                // preparo i dati da inviare per la modifica
                data = {
                    [this.state.keyReference]: {
                        [this.state.subKeyReference]: listTemp
                    }
                }
            } else {
                // preparo i dati da inviare per la modifica
                data = {
                    [this.state.keyReference]: {
                        [this.state.subKeyReference]: listTemp
                    },
                    "Ipv6": this.state.allElementV6
                }
            }
        }

        // è un indirizzo v6 da modificare?
        if (compareString(this.state.subKeyReference, 'ipv6')) {
            listTemp = this.state.allElementV6;

            if (newIp.includes("/"))
                listTemp.push(newIp);
            else
                listTemp.push(newIp + '/32');

            // controllo se la chiave iniziale aveva anche gli indirizzi v4
            if (isEmpty(this.state.allElementV4)) {
                // preparo i dati da inviare per la modifica
                data = {
                    [this.state.keyReference]: {
                        [this.state.subKeyReference]: listTemp
                    }
                }
            } else {
                // preparo i dati da inviare per la modifica
                data = {
                    "Ipv4": this.state.allElementV4,
                    [this.state.keyReference]: {
                        [this.state.subKeyReference]: listTemp
                    }
                }
            }
        }

        this.props.sendEditPreferences(WHITELIST, data);
        this.toggleModal();

        setTimeout(() => {
            this.getWhiteList();
        }, 1000)
    }

    /**
     * Modifica un indirizzo ip alla lista, e rimanda tutto al BE.
     * 
     * @param key è la chiave principale (es. Player)
     * @param subKey è la sottochiave (es. Ipv4)
     * @param ip è il nuovo indirizzo ip che si sostituirà o aggiungerà alla whitelist
     */
    editIp = (key, subKey, ip) => {
        let listTemp = [];
        let data = {};

        // è un indirizzo v4 da modificare?
        if (compareString(subKey, 'ipv4')) {
            // eslint-disable-next-line
            this.state.allElementV4.map(el => {
                listTemp.push(el);
            });

            // sostituisco il vecchio indirizzo ip con il nuovo
            listTemp.splice(this.state.keyIp, 1, ip);

            // controllo se la chiave iniziale aveva anche gli indirizzi v6
            if (isEmpty(this.state.allElementV6)) {
                // preparo i dati da inviare per la modifica
                data = {
                    [key]: {
                        [subKey]: listTemp
                    }
                }
            } else {
                // preparo i dati da inviare per la modifica
                data = {
                    [key]: {
                        [subKey]: listTemp
                    },
                    "Ipv6": this.state.allElementV6
                }
            }
        }

        // è un indirizzo v6 da modificare?
        if (compareString(subKey, 'ipv6')) {
            // eslint-disable-next-line
            this.state.allElementV6.map(el => {
                listTemp.push(el);
            });

            // sostituisco il vecchio indirizzo ip con il nuovo
            listTemp.splice(this.state.keyIp, 1, ip);

            // controllo se la chiave iniziale aveva anche gli indirizzi v4
            if (isEmpty(this.state.allElementV4)) {
                // preparo i dati da inviare per la modifica
                data = {
                    [key]: {
                        [subKey]: listTemp
                    }
                }
            } else {
                // preparo i dati da inviare per la modifica
                data = {
                    "Ipv4": this.state.allElementV4,
                    [key]: {
                        [subKey]: listTemp
                    }
                }
            }
        }
        this.props.sendEditPreferences(WHITELIST, data);
        this.toggleModal();

        setTimeout(() => {
            this.getWhiteList();
        }, 200);
    }

    /**
     * Rimuove un indirizzo ip dalla lista, e rimanda tutto al BE.
     * L'indice dell'indirizzo ip da rimuovere, è conservato nello state come keyIp.
     * 
     * @param key è la chiave principale (es. Player)
     * @param subKey è la sottochiave (es. Ipv4)
     */
    removeIp = (key, subKey) => {
        let listTemp = [];
        let data = {};

        // è un indirizzo v4 da modificare?
        if (compareString(subKey, 'ipv4')) {
            // eslint-disable-next-line
            this.state.allElementV4.map(el => {
                listTemp.push(el);
            });

            // rimuovo l'indirizzo ip
            listTemp.splice(this.state.keyIp, 1);

            // controllo se la chiave iniziale aveva anche gli indirizzi v6
            if (isEmpty(this.state.allElementV6)) {
                // preparo i dati da inviare per la modifica
                data = {
                    [key]: {
                        [subKey]: listTemp
                    }
                }
            } else {
                // preparo i dati da inviare per la modifica
                data = {
                    [key]: {
                        [subKey]: listTemp
                    },
                    "Ipv6": this.state.allElementV6
                }
            }
        }

        // è un indirizzo v6 da modificare?
        if (compareString(subKey, 'ipv6')) {
            // eslint-disable-next-line
            this.state.allElementV6.map(el => {
                listTemp.push(el);
            });

            // rimuovo l'indirizzo ip
            listTemp.splice(this.state.keyIp, 1);

            // controllo se la chiave iniziale aveva anche gli indirizzi v4
            if (isEmpty(this.state.allElementV4)) {
                // preparo i dati da inviare per la modifica
                data = {
                    [key]: {
                        [subKey]: listTemp
                    }
                }
            } else {
                // preparo i dati da inviare per la modifica
                data = {
                    "Ipv4": this.state.allElementV4,
                    [key]: {
                        [subKey]: listTemp
                    }
                }
            }
        }
        this.props.sendEditPreferences(WHITELIST, data);
        this.toggleModal();

        setTimeout(() => {
            this.getWhiteList();
        }, 200);
    }

    /**
     * Rimuove una key dalla lista.
     * 
     * @param key è la chiave da rimuovere
     */
    removeKey = (key) => {
        this.props.deleteKeyFromList(WHITELIST, key);
        this.toggleModal();

        setTimeout(() => {
            this.getWhiteList();
        }, 500);
    }

    /**
     * Invio la modifica della whitelist (che sia nuova, modifica o elimina)
     */
    sendEditWhiteList = () => {
        this.resanitizeWhiteList(this.state.getWhiteList);

        setTimeout(() => {
            let data = {
                id: WHITELIST,
                value: this.state.getWhiteList
            };

            this.props.sendEditPreferences(data);
        }, 200);

        setTimeout(() => {
            this.getWhiteList();
        }, 500);
    }

    /**
     * Ogni volta che l'utente clicca 'modifica un indirizzo ip',
     * questa funzione prende tutti i gli indirizzi ipv4 e ipv6 riferiti a quella chiave e 
     * li inserisce in delle variabili temporanee in modo da tenerli
     * salvati nello state per una possibile put futura.
     * 
     * Esempio: se voglio modificare un indirizzo che si trova all'interno id Ipv4 di player,
     * questa funzione in allElementV4 inserisce tutti gli indirizzi di Ipv4 e tutti
     * gli indirizzi Ipv6 in allElementV6
     */
    getAllIp = () => {
        // eslint-disable-next-line
        Object.keys(this.state.keyContentReference).map(item => {
            if (compareString(item, 'ipv4') && !isEmpty(this.state.keyContentReference[item])) {
                this.setState({ allElementV4: this.state.keyContentReference[item] });
            }
            if (compareString(item, 'ipv6') && !isEmpty(this.state.keyContentReference[item])) {
                this.setState({ allElementV6: this.state.keyContentReference[item] });
            }
        });
    }

    render() {
        const { role } = this.props;
        const { getWhiteList } = this.state;

        const canEdit = controlRole(role.preferences, "api/Preferences", "PUT");
        const canDelete = controlRole(role.preferences, "api/Preferences", "DELETE");
        const keys = isNull(getWhiteList) ? [] : Object.keys(getWhiteList);

        return (
            <Page>
                <PageHeader
                    title="WhiteList"
                    subtitle={`${keys.length} chiavi`}
                    actions={
                        <>
                            <FlushButtons
                                canFlush={controlRole(role.preferences, "api/Preferences/flush", "POST")}
                                canFlushConfig={controlRole(role.configFlush, "api/Config", "POST")}
                                onFlush={this.props.flush}
                                onFlushConfig={this.props.flushConfig}
                            />
                            {
                                canEdit &&
                                <button type="button" className="btn btn-sm btn-success" onClick={this.hasClickNewKey}>
                                    <i className="fas fa-plus" aria-hidden="true" /> Nuova chiave
                                </button>
                            }
                        </>
                    }
                />

                {
                    (this.props.preferences.isLoading || this.state.isLoading || this.state.loadingForRole) ? <Loading /> :
                        keys.length === 0 ?
                            <Card><div className="uiEmpty">Nessuna chiave in whitelist</div></Card>
                            :
                            <div className="uiGrid uiGrid2">
                                {
                                    keys.map(item => ( // chiave primaria (es. Player)
                                        <Card
                                            key={item}
                                            title={item.toUpperCase()}
                                            actions={
                                                canDelete &&
                                                <TextButton icon="far fa-trash-alt" variant="danger" onClick={() => { this.hasClickRemoveKey(item) }} title={"Elimina la chiave " + item}>
                                                    Elimina chiave
                                                </TextButton>
                                            }
                                        >
                                            {
                                                Object.keys(getWhiteList[item]).map(el => { // sottochiavi (es. Ipv4, Ipv6)
                                                    const addresses = getWhiteList[item][el];

                                                    return (
                                                        <div className="whiteListGroup" key={el}>
                                                            <div className="whiteListGroupHeader">
                                                                <div>
                                                                    <h4>{el}</h4>
                                                                    <span className="uiCount">{isNull(addresses) ? 0 : addresses.length} indirizzi</span>
                                                                </div>
                                                                {
                                                                    canEdit &&
                                                                    <TextButton icon="fas fa-plus" variant="success" onClick={() => { this.hasClickNewIp(item, getWhiteList[item], el) }}>
                                                                        Aggiungi indirizzo
                                                                    </TextButton>
                                                                }
                                                            </div>

                                                            <DataList
                                                                columns={[{ key: 'ip', label: 'Indirizzo', render: row => <span className="uiMono">{row.ip}</span> }]}
                                                                rows={(addresses || []).map((ip, index) => ({ ip, index }))}
                                                                rowKey={row => `${row.index}-${row.ip}`}
                                                                empty="Non ci sono indirizzi"
                                                                inline
                                                                actions={
                                                                    (canEdit || canDelete) ?
                                                                        row => (
                                                                            <>
                                                                                {canEdit && <TextButton icon="far fa-edit" onClick={() => { this.hasClickEdit(item, getWhiteList[item], el, row.ip, row.index) }}>Modifica</TextButton>}
                                                                                {canDelete && <TextButton icon="far fa-trash-alt" variant="danger" onClick={() => { this.hasClickRemoveIp(item, getWhiteList[item], el, row.ip, row.index) }}>Elimina</TextButton>}
                                                                            </>
                                                                        )
                                                                        : undefined
                                                                }
                                                            />
                                                        </div>
                                                    );
                                                })
                                            }
                                        </Card>
                                    ))
                                }
                            </div>
                }

                {
                    (this.state.hasClickEdit || this.state.hasClickNewKey || this.state.hasClickRemoveIp || this.state.hasClickRemoveKey || this.state.hasClickNewIp) &&
                    <ModalWhiteList
                        titleModal={
                            this.state.hasClickNewKey ? 'Nuova Chiave' :
                                this.state.hasClickNewIp ? 'Nuovo Indirizzo IP' :
                                    this.state.hasClickEdit ? 'Modifica IP' :
                                        this.state.hasClickRemoveIp ? 'Rimuovi IP' :
                                            this.state.hasClickRemoveKey ? 'Rimuovi Chiave' : ''
                        }

                        type={
                            this.state.hasClickNewKey ? 'newKey' :
                                this.state.hasClickNewIp ? 'newIp' :
                                    this.state.hasClickEdit ? 'edit' :
                                        this.state.hasClickRemoveIp ? 'removeIp' :
                                            this.state.hasClickRemoveKey ? 'removeKey' : ''
                        }

                        toggle={this.toggleModal}
                        stateModal={this.state.modal}

                        clickNewKey={this.addKey}
                        clickNewIp={this.addNewIp}
                        clickEdit={this.editIp}
                        clickRemoveIp={this.removeIp}
                        clickRemoveKey={this.removeKey}

                        keyReference={this.state.keyReference}
                        keyIp={this.state.keyIp}
                        subKeyReference={this.state.subKeyReference}
                        ipReference={this.state.ipReference}
                        allElementV4={this.state.allElementV4}
                        allElementV6={this.state.allElementV6}

                        key={this.state.shortId}
                        errorNotify={this.props.errorNotify}
                    />
                }
            </Page>
        )
    }
}

export default withNavigate(whitelist);